import React from "react";

import CustomParser from "modules/CustomParser";

import SkeletonWithFade from "components/Loading/SkeletonWithFade";

import LinkBadge from "components/LinkBadge/LinkBadge";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function Specification(props) {
  const { spec, loading, customClasses } = props;

  if (loading) return <SkeletonWithFade inProp />;
  if (!spec) return <div />;

  if (Array.isArray(spec)) {
    return spec.map((s) => (
      <LinkBadge
        customClasses={customClasses}
        name={s.name}
        href={s.href}
        key={"spec-" + s.href || s.name}
        disabled={!s.href}
      />
    ));
  }
  if (typeof spec === "boolean") {
    return spec && <CheckCircleIcon color="primary" />;
  }
  return (
    <div>
      <CustomParser content={spec} />
    </div>
  );
}

export default Specification;
